import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlockScreenService {
  // Controla si se muestra el componente de bloqueo de pantalla completa. Ver BlockScreenComponent
  showBlockScreen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  textBlockScreen = 'Cargando';
  textExtraBlockScreen = '';
  autoCloseBlockScreen = false;

  constructor() {}

  setBlockScreen(show: boolean, autoClose: boolean = null, text: string = null, textExtra: string = null) {
    if (text !== null) {
      this.textBlockScreen = text;
    }
    if (textExtra !== null) {
      this.textExtraBlockScreen = textExtra;
    }
    if (autoClose !== null) {
      this.autoCloseBlockScreen = autoClose;
    }
    // Se setea al último porque esto gatilla un evento que requiere de los valores anteriores
    this.showBlockScreen.next(show);
    console.log(show, autoClose, text, textExtra);
  }
}
